import { InputDateTime, InputNumber, InputText, Image } from 'components';
import { InputToggleSwitch } from 'components/toggle-switch';
import { Button, InputWraper, useForm } from 'modules';
import React, { useCallback, useEffect, useState } from 'react';
import { useCheckPhoneNumberTransferQuery } from 'services';
import { UserSearchEntity } from 'services/openapi';
import {
  useCreateReferralDetailMutation,
  useGetReferralDetailQuery,
  useUpdateReferralDetailMutation,
} from 'services/referral';
import { structure } from './config';
import toast from 'react-hot-toast';
import { formatDateTime } from 'utils/helpers/helpers';
import { checkValidActionRoleAdmin } from 'utils/helpers';
import { Actions } from 'configs/actions';

const RefferalDetailFeature = () => {
  const { mutateAsync: mutateAsyncUpdate } = useUpdateReferralDetailMutation();

  const { mutateAsync: mutateAsyncCreate } = useCreateReferralDetailMutation();

  const { data: referralProgramDetail, refetch: refetchGetReferralDetail } =
    useGetReferralDetailQuery();

  const [phoneNumber, setPhoneNumber] = useState<string>('');

  const [phoneNumberDebounce, setPhoneNumberDebounce] = useState<string>('');

  const { data: dataCheckPhoneNo, refetch } = useCheckPhoneNumberTransferQuery({
    phoneNumber,
  });

  useEffect(() => {
    const timeout = setTimeout(() => {
      setPhoneNumberDebounce(phoneNumber);
    }, 500);

    return () => clearTimeout(timeout);
  }, [phoneNumber]);

  useEffect(() => {
    if (phoneNumberDebounce) {
      refetch();
    }
  }, [phoneNumberDebounce]);

  const { handleSubmit, getInputProps, resetForm, getValue, setValues } =
    useForm({
      enableReinitialize: true,
      structure: structure(referralProgramDetail),
      onSubmit: async (values) => {
        const normalizedPhoneNumber =
          dataCheckPhoneNo?.data?.[0]?.id ||
          referralProgramDetail?.pointSenderId;
        if (!normalizedPhoneNumber) {
          toast.error('No valid phone number found');
          return;
        }
        const normalizedValues = {
          ...values,
          pointSenderId: normalizedPhoneNumber,
          startDate: formatDateTime(
            typeof values.startDate === 'string'
              ? new Date(values.startDate).getTime()
              : values.startDate,
          ),
          endDate: formatDateTime(
            typeof values.endDate === 'string'
              ? new Date(values.endDate).getTime()
              : values.endDate,
          ),
          autoActiveDate: formatDateTime(
            typeof values.autoActiveDate === 'string'
              ? new Date(values.autoActiveDate).getTime()
              : values.autoActiveDate,
          ),
        };
        try {
          if (!referralProgramDetail) {
            await mutateAsyncCreate(normalizedValues);
            refetchGetReferralDetail();
            toast.success('Tạo sự kiện thành công');
          } else {
            await mutateAsyncUpdate(normalizedValues);
            refetchGetReferralDetail();
            toast.success('Cập nhật thành công');
          }
        } catch (error) {
          toast.error('Error updating referral details');
        }
      },
    });

  const renderDataUser = React.useMemo(() => {
    if (!dataCheckPhoneNo) {
      return <div> </div>;
    }

    if (!dataCheckPhoneNo?.data?.length) {
      return <div>Không tìm thấy tài khoản</div>;
    }

    return dataCheckPhoneNo?.data?.map((item: UserSearchEntity) => (
      <div
        style={{
          width: '100%',
          display: 'flex',
          justifyContent: 'flex-start',
          marginBottom: 20,
          marginTop: -20,
        }}
      >
        <div key={item.id} className='UserHead'>
          <div className='profile ctas'>
            <Image
              src={
                item?.avatar
                  ? `${process.env.REACT_APP_UPLOAD_AVT}${item?.avatar}`
                  : '/assets/images/no-image.jpg'
              }
              type='avatar'
            />
            <div className='info'>
              <div className='name'>{item?.fullName}</div>
              <div className='email'>{item?.phoneNumber}</div>
            </div>
          </div>
        </div>
      </div>
    ));
  }, [dataCheckPhoneNo]);

  const checkCanSubmit = useCallback(() => {
    return (
      (referralProgramDetail &&
        checkValidActionRoleAdmin(Actions.ManageReferralEvent_UpdateEvent)) ||
      (!referralProgramDetail &&
        checkValidActionRoleAdmin(Actions.ManageReferralEvent_CreateEvent))
    );
  }, [referralProgramDetail]);

  return (
    <div className='container-fluid Form_UpdateEventRefferal'>
      <div className='container-fluid Form__Updateuser'>
        <div className='row wrap-form-update-refferal'>
          <InputWraper
            className='col-lg-12'
            inputProps={getInputProps('pointSenderPhoneNumber')}
            component={InputText}
            onChangeCallback={setPhoneNumber}
          />
          {renderDataUser}
          <InputWraper
            className='col-lg-12'
            inputProps={getInputProps('referralPoint')}
            component={InputNumber}
          />
          <InputWraper
            className='col-lg-12'
            inputProps={getInputProps('startDate')}
            component={InputDateTime}
          />
          <InputWraper
            className='col-lg-12'
            inputProps={getInputProps('endDate')}
            component={InputDateTime}
          />
          <InputWraper
            className='col-lg-12'
            inputProps={getInputProps('autoActiveDate')}
            component={InputDateTime}
          />
          <div className='input' style={{ width: '100%', paddingLeft: 20 }}>
            <div className='label'>Trạng thái</div>
            <InputToggleSwitch
              onChange={async (value) => {
                setValues({ active: value });
              }}
              defaultValue={getValue('active') || false}
              value={getValue('active')}
              onTouched={() => false}
              label=''
              name=''
            />
          </div>
          {checkCanSubmit() && (
            <div className='Button__update--user'>
              <Button
                label={referralProgramDetail ? 'Cập nhật' : 'Tạo mới'}
                buttonType='success'
                onClick={handleSubmit}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default RefferalDetailFeature;
